"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeIssueFooterLink = exports.addIssueFooterLink = exports.linkLabelsToLabels = exports.labelsToLinks = void 0;
var labels_1 = require("./labels");
/**
 * Replaces all labels with links: `[#tara-label-<title>]` -> `[<title>](https://app.tara.ai/orgId/teamId/tasks/task-id)`
 *
 * @param input The original message text
 * @param id id of task to link to
 * @param orgId id of task to link to
 * @returns Message with replaced labels
 */
function labelsToLinks(input, id, orgId) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, input.replace(labels_1.markdownLabelIdRegExp, function (match, label) { return "[".concat(label, "](https://app.tara.ai/").concat(orgId, "/*/tasks/").concat(id, ")"); })];
        });
    });
}
exports.labelsToLinks = labelsToLinks;
/**
 * Replaces all label links with tara label: `[<title>](https://app.tara.ai/orgId/teamId/tasks/task-id)` -> `[#tara-label-<title>]`
 *
 * @param input The original message text
 * @returns Message with replaced labels
 */
function linkLabelsToLabels(input) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, input.replace(labels_1.labelLinkRegExp, function (match, label) { return "[#tara-label-".concat(label, "]"); })];
        });
    });
}
exports.linkLabelsToLabels = linkLabelsToLabels;
/**
 * appends tara task link to end of text
 *
 * @param text The original message text
 * @param id task id for deep linking
 * @param organizationId for deep linking
 * @returns Message with link footer
 */
function addIssueFooterLink(body, id, organizationId) {
    return "".concat(body, "<br /><br />[Tara Task](https://app.tara.ai/").concat(organizationId, "/*/tasks/").concat(id, ")");
}
exports.addIssueFooterLink = addIssueFooterLink;
/**
 * removes tara task link from end of description
 *
 * @param input The original message text
 * @returns Body without footer link
 */
function removeIssueFooterLink(input) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, input.replace(labels_1.issueFooterLinkRegExp, '')];
        });
    });
}
exports.removeIssueFooterLink = removeIssueFooterLink;
